<div class="row" [formGroup]="controls">
  <div [class]="showTime ? 'col-7 pe-1' : 'col'">
    <div class="form-group">
      @if (label || (showTime && showTimeSpinners)) {
        <label class="form-label"
               [ngClass]="{'line-up-with-time-picker': showTime}"
               [for]="getElementId(ControlNames.DATE_CONTROL_NAME)">{{ label ? label : '&nbsp;' }}</label>
      }
      <div class="input-group" [class]="{'input-group-sm': isSmall}">
        <input ngbDatepicker [id]="getElementId(ControlNames.DATE_CONTROL_NAME)" class="form-control"
               [placeholder]="placeholder ?? 'yyyy-mm-dd'" [attr.aria-describedby]="helpText && getElementId('helpBlock')"
                [placement]="placement" [readOnly]="readOnly" container="body"
               #d="ngbDatepicker" [minDate]="minDateNgbDateStruct" [maxDate]="maxDateNgbDateStruct"
               [formControlName]="ControlNames.DATE_CONTROL_NAME"
               (navigate)="onNavigate($event)" (closed)="onClosed()"
               (blur)="onTouched()" (input)="onDatePickerKeypress()">
        <button class="btn btn-outline-secondary" [disabled]="d.disabled || readOnly" (click)="toggleDatePicker(d)" type="button">
          <fa-icon icon="calendar-alt" [fixedWidth]="true" [title]="'Select Date' | messageTranslate" class="clickable"/>
        </button>
      </div>
      @if (helpText) {
        <small [id]="getElementId('helpBlock')" class="form-text text-body-secondary">{{ helpText }}</small>
      }
      @if (showErrors) {
        <app-errors [errors]="errors"/>
      }
    </div>
  </div>
  @if (showTime) {
    <div class="col-5 ps-1">
      <ngb-timepicker [formControlName]="ControlNames.TIME_CONTROL_NAME" [spinners]="showTimeSpinners" (blur)="onTouched()"/>
    </div>
  }
</div>

